export default "__VITE_ASSET__bNUm$hOo__"